import { ref } from 'vue';

interface UseResizePanelOptions {
    minWidth?: number;
    maxWidth?: number;
    initialWidth?: number;
    direction?: 'left' | 'right';
}

// 左侧面板宽度百分比（共享），供 ChatPanel 与右侧内容（如 SolutionCard）使用
export const currentWidth = ref(38.2);

export function useResizePanel(options: UseResizePanelOptions = {}) {
    const {
        minWidth = 5,
        maxWidth = 95,
        initialWidth = 38.2,
        direction = 'right',
    } = options;

    if (initialWidth != null) {
        currentWidth.value = initialWidth;
    }

    const startResize = (e: MouseEvent) => {
        e.preventDefault();

        // Store the initial mouse position and panel width
        const startX = e.clientX;
        const startWidth = currentWidth.value;
        (e.target as HTMLElement).style.width = '4px';

        const handleMouseMove = (moveEvent: MouseEvent) => {
            const containerRect = document.body.getBoundingClientRect();
            const deltaX = moveEvent.clientX - startX;
            let newWidth;

            if (direction === 'right') {
                // Right panel: calculate width based on the delta movement
                newWidth = startWidth + ((-deltaX / containerRect.width) * 100);
            } else {
                // Left panel: calculate width based on the delta movement
                newWidth = startWidth + ((deltaX / containerRect.width) * 100);
            }

            // Limit width between minWidth and maxWidth（写入共享 ref）
            currentWidth.value = Math.min(Math.max(newWidth, minWidth), maxWidth);
        };

        const handleMouseUp = () => {
            (e.target as HTMLElement).style.removeProperty('width');
            document.removeEventListener('mousemove', handleMouseMove);
            document.removeEventListener('mouseup', handleMouseUp);
        };

        document.addEventListener('mousemove', handleMouseMove);
        document.addEventListener('mouseup', handleMouseUp);
    };

    return {
        currentWidth,
        startResize,
    };
}
